import { useNavigate } from "react-router-dom";

const getRandomIdx = (length) => Math.floor(Math.random() * length);

const AdvWidgetBannerList = ({ bannerGroups = [], ratio }) => {
    const navigate = useNavigate();
    const banners = bannerGroups.map((group) => group[getRandomIdx(group.length)]);

    const handleBannerClick = (banner) => {
        if (!banner.to) return;
        if (!banner.target) {
            return navigate(banner.to);
        }
        const newWindow = window.open(banner.to, "_blank");
        if (newWindow) {
            newWindow.focus();
        } else {
            alert("팝업 차단 설정이 활성화되어 새 창을 열 수 없습니다.");
        }
    };

    return banners.map((banner, idx) => (
        <a
            key={idx}
            href="#"
            className="adv-widget"
            data-ratio={ratio}
            onClick={(e) => {
                e.preventDefault();
                handleBannerClick(banner);
            }}
        >
            <img src={banner.src} alt="" />
        </a>
    ));
};

export default AdvWidgetBannerList;
